import axios from 'axios';

import { API_ENDPOINT } from 'constants/envVars';
import { SESSION_EXPIRED_FLAG, TOKEN_DATA_KEY, USER_DATA_KEY } from '../constants/login';
import { HOME_PAGE } from '../constants/routes';

let isHandlingUnauthorized = false;

function handleUnauthorized() {
  if (isHandlingUnauthorized) return;
  isHandlingUnauthorized = true;

  localStorage.removeItem(TOKEN_DATA_KEY);
  localStorage.removeItem(USER_DATA_KEY);
  sessionStorage.setItem(SESSION_EXPIRED_FLAG, '1');
  window.location.assign(HOME_PAGE);
}

function attachUnauthorizedInterceptor(instance) {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const sentAuthHeader = Boolean(error?.config?.headers?.Authorization);
      if (error?.response?.status === 401 && sentAuthHeader) {
        handleUnauthorized();
      }
      return Promise.reject(error);
    },
  );

  return instance;
}

function axiosDefault(reduxToken = '') {
  const token = reduxToken || localStorage.getItem(TOKEN_DATA_KEY);
  if (!token) {
    return attachUnauthorizedInterceptor(
      axios.create({
        baseURL: API_ENDPOINT,
      }),
    );
  }

  return attachUnauthorizedInterceptor(
    axios.create({
      baseURL: API_ENDPOINT,
      headers: {
        common: {
          Authorization: `Bearer ${token}`,
        },
      },
    }),
  );
}

export default axiosDefault;
